import { HouseholdDetailRequest, HouseholdDetailResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface, HouseholdDetail, HouseholdDetailLookup } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostStreetviewHouseholdDetail extends BaseAdapter<HouseholdDetailResponse> implements AdapterInterface {
  rawResponse: HouseholdDetailResponse;

  modifiedRequest: HouseholdDetailRequest;

  async adaptResponse(request: HouseholdDetailLookup, signal?: AbortSignal): Promise<HouseholdDetail> {
    const formattedRequest = this.adaptRequest(request);

    await this.fetchApiResponse('/api/streetview-household-detail', HTTPMethod.Post, formattedRequest, signal);
    return this.displayResponse();
  }

  displayResponse(): HouseholdDetail {
    return {
      householdReference: this.rawResponse.household_reference,
      incomeAfterCosts: this.rawResponse.income_aftercosts,
      takeHomeIncome: this.rawResponse.hh_takehomeincome,
      arrearsBalance: this.rawResponse.arrears_balance,
      riskGroup: this.rawResponse.risk_group,
      householdType: this.rawResponse.demo_householdtype,
      economicStatus: this.rawResponse.demo_economicstatus,
      tenure: this.rawResponse.demo_tenure,
      disability: this.rawResponse.demo_disability,
      monthlyRent: this.rawResponse.monthly_rent,
      numberOfChildren: this.rawResponse.input_number_of_children,
      numberOfNonDependants: this.rawResponse.input_numberof_nondependants,
      energyRating: this.rawResponse.current_energy_rating,
    };
  }

  adaptRequest(request: HouseholdDetailLookup): HouseholdDetailRequest {
    this.modifiedRequest = {
      lift_client_name: request.clientName,
      snapshot: request.snapshot,
      lift_household_reference: request.householdReference,
    };
    return this.modifiedRequest;
  }
}
